'use client'
import { cloneElement, HTMLAttributes, ReactElement } from 'react'
import { useTrackClick } from '../../hooks'
import { TrackerProps } from '@avia/tracker'

interface TrackClickProps extends TrackerProps {
  children: ReactElement<HTMLAttributes<HTMLElement>>
}

export function TrackClick({ children, config }: TrackClickProps) {
  const click = useTrackClick(config)

  return cloneElement(children, {
    onClick: (e) => {
      const { onClick } = children.props
      click()
      if (onClick) {
        onClick(e)
      }
    },
  })
}
